import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.data-source-bindings__form', () => {
  void import('./internal/data-source-bindings__form')
    .then(({ default: Component }) => Component());
});
